import React from 'react';
import { spaTheme } from '@recurrent/shared';
import { CssBaseline } from '@material-ui/core';
import {
  PreferencesSection,
  TranslationProvider,
} from '@recurrent/shared/build/components';
import {
  BrowserPreferencesProvider,
  ProviderWithConfig,
  ThemeProvider,
} from '@recurrent/shared/build/providers';

import PaymentProvider from '../PaymentProvider';

const App = () => (
  <ProviderWithConfig>
    <BrowserPreferencesProvider>
      <ThemeProvider theme={spaTheme}>
        <CssBaseline>
          <TranslationProvider>
            <PreferencesSection />

            <PaymentProvider />
          </TranslationProvider>
        </CssBaseline>
      </ThemeProvider>
    </BrowserPreferencesProvider>
  </ProviderWithConfig>
);

export default App;
